var React = require('react');

function Users (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 3.5C6 2.11929 4.88071 1 3.5 1C2.11929 1 1 2.11929 1 3.5C1 4.88071 2.11929 6 3.5 6C4.88071 6 6 4.88071 6 3.5ZM9 2C10.1046 2 11 2.89543 11 4C11 5.10457 10.1046 6 9 6C7.89543 6 7 5.10457 7 4C7 2.89543 7.89543 2 9 2ZM7 9C6.33333 7.66667 5.16667 7 3.5 7C1.83333 7 0.666667 7.66667 0 9V11H7V9ZM12 9C11.3333 7.66667 10.3333 7 9 7C8.31606 7 7.71984 7.17541 7.2129 7.52577C7.52222 7.8798 7.78532 8.29582 8 8.77598L7.9999 11H12V9Z","fill":"currentColor"}));
}

Users.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Users;

Users.default = Users;
